import { theme, cytoscapeStyle } from "./templates/flowchart-fun/default-template";
import { getDefaultText } from "./getDefaultText";

const defaultMeta = {
  themeEditor: theme,
  cytoscapeStyle,
};

// TODO: Should be shared with the back-end through a shared package
function getMetaBase(diagramTool: string) {
  if (diagramTool === "flowchart-fun") {
    return `\n=====\n${JSON.stringify(
      {
        defaultMeta,
        diagramTool
      },
      null,
      2
    )}\n=====`;
  } else {
    return `\n=====\n${JSON.stringify(
      {
        diagramTool,
      },
      null,
      2
    )}\n=====`;
  }
}

export function getDefaultChart(diagramTool: string = "mermaid") {
  return `${getDefaultText()}\n${getMetaBase(diagramTool)}`;
}
